<template>
    <el-dialog title="查看详情" width="50%" :visible.sync="dialogVisible" ref="myDialog">
        
        <div>
            <b> {{ title }}最新期</b> ：
            <span style="color:blue">
                {{ db.additionalIndicators }}
            </span>
        </div>
        <hr>
        <b style="margin-bottom: 10px;display: block;">历史期</b>
        <div v-for="item in historical_periods" :key="item.recordId" style="line-height: 20px;">
            <div v-html="handleTitle(item)"></div>
            <div style="margin: 5px 0;border-bottom: 1px solid #ccc;">
                <!-- <div style="color: blue;"><b>开奖号</b>： {{item.openNbr}}</div> -->
                <div style="display:flex"><b>开奖号</b>：
                    <div v-html="handlekaijianghao(item)"></div>
                </div>
                <div style="display:flex;margin: 5px 0;">
                    <!-- <b>开奖验证</b>： <div v-html="handleHtml(item)"></div> -->
                </div>
            
            </div>
        </div>
    </el-dialog>
</template>

<script>

export default {
    computed: {
        handleTitle() {
            return (item) => {
                // console.log('handleTitle item', JSON.parse(JSON.stringify(item)));
                let {openNbr, expand} = item
                let openBbr_last = openNbr.split(' ').slice(-1),
                    expand_arr = expand.split(' ');
                
                // console.log('openBbr_last',openBbr_last);
                // console.log('expand_arr',expand_arr);
                
                let rightOrFalse = '';
                
                let str = ''
                // 杀6蓝
                if (item.preIndexType === '5') {
                    rightOrFalse = _.intersection(openBbr_last, expand_arr).length > 0 ? `<b style="color:red">错误</b>` : `<b style="color:green">正确</b>`
                    expand_arr.forEach((item) => str += item === openBbr_last[0] ? `<b style="color:#000">${item}</b> ` : `<b style="color:red">${item}</b> `)
                }
                // 围4蓝
                if (item.preIndexType === '6') {
                    rightOrFalse = _.intersection(openBbr_last, expand_arr).length > 0 ? `<b style="color:green">正确</b>` : `<b style="color:red">错误</b>`
                    expand_arr.forEach((item) => str += item === openBbr_last[0] ? `<b style="color:red">${item}</b> ` : `<b style="color:#000">${item}</b> `)
                }
                
                console.log('rightOrFalse', rightOrFalse);
                
                
                let tit = item.title.split('-');
                tit[2] = `${tit[2] || this.indexName}(<b style="color:red">${str}</b>)`;
                return tit.slice(0, 3).join('-') + '-' + rightOrFalse;
                
                
            }
        },
        handlekaijianghao() {
            return function (item) {
                // 杀6蓝
                if (item.preIndexType == 5 && item.openNbr) {
                    let aa = item.openNbr.split(' ')
                    
                    let result = `
						<span style="color:red">${aa.slice(0, 6).join(' ')}</span>
						+
						<span style="color:blue">${aa.slice(-1)}</span>
					`
                    return result;
                }
                // 围4蓝
                if (item.preIndexType == 6) {
                    let aa = item.openNbr.split(' ')
                    let result = `
						<span style="color:red">${aa.slice(0, 6).join(' ')}</span>
						+
						<span style="color:blue">${aa.slice(-1)}</span>
					`
                    return result;
                    // return ` <span style="color:blue"> ${item.openNbr} </span> `
                }
            }
        },
        handleHtml() {
            return function (item) {
                
                // console.log('item', JSON.parse(JSON.stringify(item)));
                
                // 假设 item.expand 和 item.openNbr 是两个数组
                const expandArray = item.expand && item.expand.split(' ');
                const openNbrArray = item.openNbr && item.openNbr.split(' ');
                
                if (expandArray && openNbrArray) {
                    
                    
                    console.log('item.preIndexType', item.preIndexType);
                    // 杀6蓝
                    if (item.preIndexType == 5) {
                        console.log(expandArray, openNbrArray);
                    }
                    // 围4蓝
                    if (item.preIndexType == 6) {
                        // 找到两个数组中的相同元素
                        const commonElements = expandArray.filter(element => openNbrArray.includes(element));
                        
                        // 构建返回的HTML
                        const result = expandArray.map(element => {
                            if (commonElements.includes(element)) {
                                return `<span style="color: red; font-weight: bold;">${element}</span>`;
                            } else {
                                return element;
                            }
                        }).join(', ');
                        
                        return result;
                    }
                }
            }
        }
        
    },
    data() {
        return {
            dialogVisible: false,
            
            title: '',
            indexName: '',
            
            db: {},
            historical_periods: [],
        }
    },
    methods: {
        
        init(res) {
            
            let {indexName, preType, data} = res;
            
            this.dialogVisible = true;
            this.db = data[0];
            
            let pretypeObj = ['双色球', '大乐透', '福彩3D', '排列三'];
            this.title = `${pretypeObj[preType]}${indexName}`;
            this.indexName = indexName;
            
            this.historical_periods = data[0].indicatorsHistory;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
